/*
 * @Author: Teemo Ding
 * @Date: 2021-07-15 18:15:56
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-06 10:45:15
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Components/Webhooks/index.tsx
 */
import { Button } from '@/src/components/Antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import Link from '@/src/components/Link/Link';
import { copyToClip } from '@/src/tools/helper';
import { message } from 'antd';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';

const Webhooks = ({
  url,
  text,
  link,
  linkText,
  disabled,
  disableCopy,
}: any) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const copyURl = () => {
    copyToClip(url);
    message.success(getI18n('general.uRLcopiedtoclipboard'));
  };

  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.containerClassName}
      rightPart={''}
      title={getI18n('general.webhooks')}>
      {disabled ? null : (
        <React.Fragment>
          <p>
            {text}
            <Link to={link} className={css.link}>
              {linkText}
            </Link>
          </p>
          <h3 className={css.url}>{url}</h3>
          <Button type='primary' ghost onClick={copyURl} disabled={disableCopy}>
            {getI18n('general.copy')}
          </Button>
        </React.Fragment>
      )}
    </SectionWrapper>
  );
};

export default Webhooks;
